module.exports = __webpack_public_path__ + "img/1_011.47a825ce.jpg";